import { Col, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import NetwalaModal from "../Items/Modal/Index";
import NetwalaSelect from "../Items/Select/Index";
import "./styles/RequestIPTVModal.css";
const UpdateInternetConnectionModal: React.FC<UpdateConnectionModalProp> = ({
  show,
  handleClose,
  connection,
}) => {
  const [form] = Form.useForm();

  const { openNotification, contextHolder } = useMultiNotification();
  const [selectedArea, setSelectedArea] = useState("");
  const [selectedSubArea, setSelectedSubArea] = useState<null | string>(null);
  const [areas, setAreas] = useState<NetwalaSelectOptions[]>([]);
  const [subAreas, setSubAreas] = useState<NetwalaSelectOptions[]>([]);
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<UpdateInternetConnectionApiProp>(
    "connections/updateInternetConnectionDetails",
    true
  );

  const [
    getAreasApi,
    areasApiResponse,
    areasApiError,
    areasApiLoading,
    areasApiMessage,
    areasApiErrorCount,
  ] = useAxiosPost<ResponseProp>("areas/getAreasByOwner");
  const [
    getSubAreasApi,
    subAreasApiResponse,
    subAreasApiError,
    subAreasApiLoading,
    subAreasApiMessage,
    subAreasApiErrorCount,
  ] = useAxiosPost<SubAreasByAreaIDApiProp>("areas/getSubAreasByAreaID");

  useEffect(() => {
    if (connection.parent_intPkAreaID) {
      getSubAreasApi({ intPkAreaID: connection.parent_intPkAreaID });
    } else {
      getSubAreasApi({ intPkAreaID: connection.intPkAreaID });
    }
    getAreasApi({});
  }, []);

  useEffect(() => {
    if (areasApiResponse !== null) {
      const data: any = areasApiResponse.responseData;
      const areas = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: item.intPkAreaID,
          label: item.areaName,
        };
      });

      setAreas(areas);
    }
  }, [areasApiResponse]);
  useEffect(() => {
    if (subAreasApiResponse !== null) {
      const data: any = subAreasApiResponse.responseData;
      const subAreas = data.map((item: any): NetwalaSelectOptions => {
        return {
          value: item.intPkAreaID,
          label: item.areaName,
        };
      });

      setSubAreas(subAreas);
    }
  }, [subAreasApiResponse]);

  const onFinish = (values: any) => {
    const { address, area, subArea } = values;
    console.log({ area, subArea });
    const dataToSend: UpdateInternetConnectionApiProp = {
      intPkConnectionID: connection.intPkConnectionID,
      address,
      firstName: values.firstName,
      lastName: values.lastName,
      phoneNumber: values.phoneNumber,
      nicNumber: values.nicNumber || null,
      username: values.username?.trim(),
      password: values.password,
      areaId: subArea ? subArea : area,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);

  const onFinishFailed = (errorInfo: any) => {};

  const handleAreaChange = (value: string) => {
    setSelectedSubArea(null);
    form.setFieldsValue({ subArea: undefined });

    getSubAreasApi({ intPkAreaID: Number(value) });
  };
  const validateConfirmPassword = (_: any, value: string) => {
    const { password } = form.getFieldsValue();
    console.log({ password });
    if (value && value !== password) {
      return Promise.reject(
        new Error("The two passwords that you entered do not match!")
      );
    }
    return Promise.resolve();
  };

  return (
    <>
      <NetwalaModal
        title="Update Internet Connection"
        headerStyle={{
          backgroundColor: "#292D8E",
          color: "#FFFFFF",
          fontSize: "16px",
          fontWeight: "400",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        {contextHolder}
        <Row>
          <Col span={24} className="iptv-modal-package-details">
            <Form
              requiredMark={false}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              form={form}
              name="updateInternetConnectionForm"
              initialValues={{
                address: connection.address,
                firstName: connection.firstName,
                lastName: connection.lastName,
                phoneNumber: connection.phoneNumber,
                nicNumber: connection.nicNumber || "",
                confirmPassword: connection.password,
                password: connection.password,
                username: connection.username,
                subArea: connection.parent_intPkAreaID
                  ? connection.intPkAreaID
                  : null,
                area: connection.parent_intPkAreaID
                  ? connection.parent_intPkAreaID
                  : connection.intPkAreaID,
              }}
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">First Name</span>
                }
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "Please enter First Name",
                  },
                  {
                    validator: (_, value) => {
                      if (value) {
                        if (value.includes("'")) {
                          return Promise.reject(
                            "First Name cannot contain single quote (') character"
                          );
                        }
                        if (value.includes("--")) {
                          return Promise.reject(
                            "First Name cannot contain (--) pattern "
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="John"
                />
              </Form.Item>
              <Form.Item
                label={
                  <span className="create-user-form-label">Last Name</span>
                }
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: "Please enter Last Name",
                  },
                  {
                    validator: (_, value) => {
                      if (value) {
                        if (value.includes("'")) {
                          return Promise.reject(
                            "Last Name cannot contain single quote (') character"
                          );
                        }
                        if (value.includes("--")) {
                          return Promise.reject(
                            "Last Name cannot contain (--) pattern "
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Doe"
                />
              </Form.Item>
              <Form.Item
                label={
                  <span className="create-user-form-label">Phone Number</span>
                }
                name="phoneNumber"
                rules={[
                  {
                    required: true,
                    message: "Please enter Phone number",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="03001235467"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="create-user-form-label">NIC Number</span>
                }
                name="nicNumber"
              >
                <Input
                  className="user-input-general-height"
                  placeholder="12345-1234567-1"
                />
              </Form.Item>

              <Form.Item
                label={<span className="create-user-form-label">Address</span>}
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Please enter Address",
                  },
                  {
                    validator: (_, value) => {
                      if (value) {
                        if (value.includes("'")) {
                          return Promise.reject(
                            "Address cannot contain single quote (') character"
                          );
                        }
                        if (value.includes("--")) {
                          return Promise.reject(
                            "Address cannot contain (--) pattern "
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="House No."
                />
              </Form.Item>

              <Form.Item
                label={<span className="create-user-form-label">UserName</span>}
                name="username"
                rules={[
                  {
                    required: true,
                    message: "Please enter UserName",
                  },
                  {
                    pattern: /^[a-zA-Z0-9@._-]+$/,
                    message:
                      "Username can only contain letters, numbers, @, period (.), underscore (_), and hyphen (-)",
                  },
                  {
                    whitespace: true,
                    message: "Username cannot be empty or contain only spaces",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="johnDeo121"
                />
              </Form.Item>
              <Form.Item
                label={<span className="create-user-form-label">Password</span>}
                name="password"
                getValueFromEvent={(e) => e.target.value.trimStart()} // prevent leading spaces
                rules={[
                  {
                    required: true,
                    message: "Please enter Password",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.trim().length === 0) {
                        return Promise.reject(
                          "Password cannot be empty or contain only spaces"
                        );
                      }
                      if (value && /\s/.test(value)) {
                        return Promise.reject("Password cannot contain spaces");
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Password"
                  onBlur={(e) => {
                    e.target.value = e.target.value.trim(); // remove trailing spaces when done typing
                  }}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="create-user-form-label">
                    Confirm Password
                  </span>
                }
                dependencies={["password"]}
                name="confirmPassword"
                getValueFromEvent={(e) => e.target.value.trimStart()} // prevent leading spaces
                rules={[
                  {
                    required: true,
                    message: "Please enter Password",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.trim().length === 0) {
                        return Promise.reject(
                          "Confirm Password cannot be empty or contain only spaces"
                        );
                      }
                      if (value && /\s/.test(value)) {
                        return Promise.reject(
                          "Confirm Password cannot contain spaces"
                        );
                      }
                      if (value) {
                        if (value.length < 3) {
                          return Promise.reject(
                            "Confirm Password must contain at least 3 characters"
                          );
                        }
                        // Check if password contains letters, and if so, require at least 3 letters
                        const hasLetters = /[a-zA-Z]/.test(value);
                        if (hasLetters) {
                          const letterCount = (value.match(/[a-zA-Z]/g) || [])
                            .length;
                          if (letterCount < 3) {
                            return Promise.reject(
                              "Confirm Password must contain at least 3 letters"
                            );
                          }
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                  {
                    validator: validateConfirmPassword,
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Password"
                  onBlur={(e) => {
                    e.target.value = e.target.value.trim(); // remove trailing spaces when done typing
                  }}
                />
              </Form.Item>
              <Form.Item
                label={<span className="create-user-form-label">Area</span>}
                name="area"
                rules={[
                  {
                    required: true,
                    message: "Please Select Area",
                  },
                ]}
              >
                <NetwalaSelect
                  showSearch
                  value={selectedArea}
                  onChange={handleAreaChange}
                  size="large"
                  height="45px"
                  options={areas}
                  allowClear
                />
              </Form.Item>

              <Form.Item
                label={<span className="create-user-form-label">Sub Area</span>}
                name="subArea"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter Sub Area",
                //   },
                // ]}
              >
                <NetwalaSelect
                  showSearch
                  value={selectedSubArea}
                  size="large"
                  height="45px"
                  options={subAreas}
                  allowClear
                />
              </Form.Item>

              <Form.Item>
                <NetwalaButton
                  backgroundColor={ButtonProps.background.YELLOW}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Submit"
                  borderColor="#FFA726"
                  disabled={apiLoading}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </NetwalaModal>
    </>
  );
};

export default UpdateInternetConnectionModal;
